// extracted by mini-css-extract-plugin
module.exports = {"button":"ButtonTextOnly_button__v4_GE","size-S":"ButtonTextOnly_size-S__e9Qe2","size-M":"ButtonTextOnly_size-M__BBXDw","size-L":"ButtonTextOnly_size-L__rHJDP"};